<nav class="navigation">
  <ul>
    <li
      data-cy="company-page-navigation"
      *ngFor="let page of pages"
      [ngClass]="{'active' : checkActiveCondition(page.link)}"
    >
      <a
        (click)="redirect(page.link, page.queryParams)"
        [attr.data-cy]="'navigation-left-' + page.link"
      >
        {{ page.title }}
      </a>
    </li>
  </ul>
</nav>
